import { ShortCode } from '@highereducation/wordpress';
import {
  List,
  type ArrowDirection,
  type ListMarkerColor,
  ListProps,
} from '@highereducation/hen-ui';

interface ListShortcodeProps extends ListProps {
  variant?: 'unordered' | 'ordered';
  'bullet-style'?:
    | 'none'
    | 'bullet'
    | 'check'
    | 'square'
    | 'number'
    | 'arrows'
    | 'q'
    | 'x';
  'arrow-direction'?: ArrowDirection;
  'marker-color'?: ListMarkerColor;
  [key: string]: any;
}

export const ListShortcode: ShortCode<ListShortcodeProps> = {
  balanced: true,
  component: ({
    variant = 'unordered',
    'bullet-style': bulletStyle = 'check',
    'arrow-direction': arrowDirection,
    'marker-color': markerColor,
    children,
  }) => {
    return (
      <List
        variant={variant}
        bulletStyle={bulletStyle}
        arrowDirection={bulletStyle === 'arrows' ? arrowDirection : undefined}
        markerColor={markerColor}
      >
        {children}
      </List>
    );
  },
};
